import { getAdm, getAdmSummary } from "../utils/userHelper"

export const queryAdmUser = {
  async admUser(parent, args, context, info) {
    let { admNumber } = args

    let admUser = null

    if (admNumber) {
      admUser = await getAdm({ admNumber: admNumber })
    }

    if (!admUser) return null

    const { custom: defaultBillingAddressId, addresses } = admUser
    const admSummary = await getAdmSummary({ admNumber })

    return {
      ...admUser,
      customAdmFields: {
        ...admSummary,
      },
      defaultBillingAddress: addresses.find((address) => address?.id === defaultBillingAddressId) ?? null,
    }
  },
}
